export default __webpack_public_path__ + "static/media/fold.94056d2b.svg";